<script setup>
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="goBack" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
              Kontraktor : {{ kontraktor.namaKontraktor }}
            </button>
          </div>
          <div class="bg-white rounded-top-10 w-100" style="min-height: 60vh">
            <div class="container p-5">
              <div class="row mb-5">
                <div class="col-md-12">
                  <div class="d-flex">
                    <div class="pr-2" style="margin-right: 1rem">
                      <font-awesome-icon
                        v-if="url_icon == ''"
                        icon="fa-solid fa-building"
                        style="height: 3rem; color: #df4444"
                      />
                      <img :src="url_icon" style="height: 3rem" />
                    </div>
                    <div class="row w-100">
                      <div class="col-md-6">
                        <p
                          class="mb-1"
                          style="
                            font-size: 2rem;
                            line-height: 1.5rem;
                            font-family: 'Inter-Bold';
                          "
                        >
                          {{ kontraktor.namaKontraktor }}
                        </p>
                        <div style="font-size: 1rem">
                          Nilai Prakualifikasi :
                          {{ kontraktor.nilaiPraKplh }} | Predikat PJP :
                          <span
                            v-if="kontraktor.predikat == 'HIJAU'"
                            class="text-success"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          <span
                            v-else-if="kontraktor.predikat == 'EMAS'"
                            style="color: #e19140"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          <span
                            v-else-if="kontraktor.predikat == 'BIRU'"
                            style="color: #326bd5"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          <span
                            v-else-if="kontraktor.predikat == 'HITAM'"
                            style="color: #171716"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          <span
                            v-else-if="kontraktor.predikat == 'MERAH'"
                            class="text-danger"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          <!--                              &nbsp;&nbsp;<button type="button" class="btn btn_cari" data-bs-toggle="modal" data-bs-target="#editPjp">
                              <font-awesome-icon icon="fa-solid fa-edit" style=""/> Edit PJP
                            </button>-->
                        </div>
                      </div>
                      <div class="col-md-3">
                        <!--                            <button type="button" @click="redirectToLink('/editprofile/', id_kontraktor)" class="btn btn_cari w-100" >
                              Edit Profile (View Only)
                            </button>-->
                      </div>
                      <div class="col-md-3">
                        <!--                            <button type="button" class="btn btn_cari w-100" data-bs-toggle="modal" data-bs-target="#editKualifikasi">
                              Edit Kualifikasi Usaha
                            </button>-->
                      </div>
                      <div
                        class="modal fade rounded-top-5"
                        id="editKualifikasi"
                        tabindex="-1"
                        aria-labelledby="editKualifikasi"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog-centered rounded-top-5">
                          <div
                            class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                            style="min-height: 156px; min-width: 350px"
                          >
                            <div
                              class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                              style="
                                min-height: 100px;
                                min-width: 350px;
                                background: rgba(181, 26, 26, 1);
                              "
                            >
                              <div class="d-flex justify-content-end w-100 p-2">
                                <button
                                  type="button"
                                  id="btnClose"
                                  class="btn"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <img
                                    src="../../assets/icons/close_whaite.png"
                                    alt="icon"
                                    width="24"
                                    height="24"
                                  />
                                </button>
                              </div>
                              <div
                                class="p-3 text-white text-center mb-3"
                                style="font-family: Inter, sans-serif"
                              >
                                <h4 class="fw-bold">Edit Kualifikasi Usaha</h4>
                              </div>
                            </div>
                            <div class="modal-body">
                              <div class="p-1">
                                <form @submit.prevent="OnFormSubmit">
                                  <div class="d-flex justify-content-center">
                                    <div
                                      class="form-group mt-1 mb-2"
                                      style="width: 75%"
                                    >
                                      <select
                                        class="form-select form-select-sm"
                                        name="kualifikasiUsaha"
                                        id="kualifikasiUsaha"
                                        v-model="selectedOption"
                                      >
                                        <option disabled value="" selected>
                                          Pilih Kualifikasi Usaha
                                        </option>
                                        <option
                                          :value="row.value"
                                          v-for="(row, index) in options"
                                          :key="index"
                                        >
                                          {{ row.label }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="d-flex justify-content-center">
                                    <button
                                      type="submit"
                                      class="btn btn-sm bg-danger w-75 text-white"
                                    >
                                      Simpan
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col-md-9">
                  <!--                <button type="button" class="btn btn_cari mb-3" data-bs-toggle="modal" data-bs-target="#upload_coc_pjo" style="margin-top: -1rem;">-->
                  <!--                  <font-awesome-icon icon="fa-solid fa-cloud-arrow-up" style=""/> Upload CoC & Surat Pengesahan PJO-->
                  <!--                </button>-->
                  <table class="table table-borderless" v-if="sio">
                    <tbody
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      <tr>
                        <td width="20%">Dokumen CoC</td>
                        <td width="1%">:</td>
                        <td>
                          <i
                            v-if="
                              sio.documentIdSio == null ||
                              sio.documentIdSio == ''
                            "
                            class="text-danger"
                            >Belum ada dokumen CoC</i
                          >
                          <a
                            v-else
                            @click="downloadFileEsign(sio.documentIdSio, 'coc')"
                            class="text-danger pointer"
                          >
                            <font-awesome-icon
                              style="color: #dd3737; cursor: pointer"
                              icon="fa-solid fa-file-arrow-down"
                            />
                            Download Dokumen CoC
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>Pengesahan PJO</td>
                        <td>:</td>
                        <td>
                          <a
                            v-if="sio?.documentIdPjo && sio?.documentIdPjo != ''"
                            @click="downloadFileEsign(sio.documentIdPjo, 'pjo')"
                            class="text-danger cursor-pointer"
                          >
                            <font-awesome-icon
                              style="color: #dd3737; cursor: pointer"
                              icon="fa-solid fa-file-arrow-down"
                            />
                            Download Surat Pengesahan PJO
                          </a>
                          <i v-else class="text-danger">
                            Belum ada surat pengesahan PJO
                          </i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    INFORMASI UMUM
                  </p>
                  <div class="d-flex mb-1">
                    <p
                      class="me-5"
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      Inisial : {{ kontraktor.inisial }}
                    </p>
                    <p
                      class="me-5"
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      Klasifikasi : {{ kontraktor.jenis }}
                      <!--                          <button type="button" class="btn btn-sm btn_cari" data-bs-toggle="modal" data-bs-target="#editKlasifikasi">
                            <font-awesome-icon icon="fa-solid fa-edit" style=""/>
                          </button>-->
                    </p>
                    <p
                      class="me-5"
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-location-dot"
                        style=""
                      />
                      {{
                        kontraktor.wilayah == null ? "-" : kontraktor.wilayah
                      }}
                    </p>
                    <p
                      class="me-5"
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      Kualifikasi Usaha :
                      {{
                        kontraktor.kualifikasiUsaha == 1
                          ? "Kecil"
                          : kontraktor.kualifikasiUsaha == 2
                          ? "Sedang"
                          : kontraktor.kualifikasiUsaha == 3
                          ? "Besar"
                          : "-"
                      }}
                    </p>
                  </div>
                  <!-- <hr class="hr" /> -->
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    IZIN LEGALITAS
                  </p>
                  <div class="d-flex mb-2">
                    <table class="table table-borderless">
                      <tbody
                        style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                      >
                        <tr>
                          <td width="15%">No. NIB</td>
                          <td width="1%">:</td>
                          <td width="25%">
                            {{ kontraktor.nib == null ? "-" : kontraktor.nib }}
                          </td>
                        </tr>
                        <tr>
                          <td>No. IUJP</td>
                          <td>:</td>
                          <td>
                            {{
                              kontraktor.iujp == null ? "-" : kontraktor.iujp
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Masa Berlaku</td>
                          <td>:</td>
                          <td>
                            {{
                              kontraktor.masaBerlaku == null
                                ? "-"
                                : moment(kontraktor.masaBerlaku).format(
                                    "DD MMMM YYYY"
                                  )
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div
                    class="rounded w-100 p-3"
                    style="min-height: 10vh; background-color: #fff1f1"
                  >
                    <p
                      class="mb-1"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      INFORMASI PJO
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Bold'; font-size: 1.1rem"
                    >
                      {{ kontraktor.namaPjo }}
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                    >
                      No. Surat Pengesahan :
                      {{ kontraktor.noPengesahanPjo }}
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                    >
                      Tgl Surat Pengesahan :
                      {{
                        kontraktor.tglSuratPengesahan != "" &&
                        kontraktor.tglSuratPengesahan != null
                          ? moment(kontraktor.tglSuratPengesahan).format(
                              "DD MMM YYYY"
                            )
                          : "-"
                      }}
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                    >
                      <a
                        v-if="kontraktor?.filePengesahan"
                        @click="downloadFile(kontraktor.filePengesahan, `File Pengesahan ${kontraktor.namaKontraktor}`)"
                        class="text-danger cursor-pointer"
                      >
                        <font-awesome-icon
                          style="color: #dd3737; cursor: pointer"
                          icon="fa-solid fa-file-arrow-down"
                        />
                        Surat Pengesahan
                      </a>
                      <i v-else class="text-danger">
                        Belum ada Surat Pengesahan
                      </i>
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-user-check"
                        style="color: #df4444"
                      />
                      {{ kontraktor.kompetensiPjo }}
                    </p>
                    <p
                      class="mb-1 mt-2"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      INFORMASI PIC
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Medium'; font-size: 0.8rem"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-envelope"
                        style="color: #df4444"
                      />
                      {{ kontraktor.picEmail }}
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Medium'; font-size: 0.8rem"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-phone"
                        style="color: #df4444"
                      />
                      {{ kontraktor.picPhone }}
                    </p>
                  </div>
                </div>
                <div class="col-md-12">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    Kode KBLI
                  </p>
                  <div class="table-responsive">
                    <table class="table table-striped rounded">
                      <thead
                        style="
                          font-family: 'Inter-Regular';
                          font-style: normal;
                          font-weight: 500;
                          font-size: 14px;
                          line-height: 24px;
                          color: #28293d;
                        "
                      >
                        <tr class="table-danger" style="max-height: 5vh">
                          <th width="6%">Kode</th>
                          <th width="20%">Judul</th>
                          <th class="text-center" width="14%">
                            Tingkat Resiko
                          </th>
                          <th class="text-center" width="10%">
                            Sertifikat Standar
                          </th>
                          <th class="text-center" width="10%">Izin</th>
                          <th class="text-center" width="8%">Is Verified</th>
                          <th class="text-center" width="23%">Catatan</th>
                        </tr>
                      </thead>
                      <tbody
                        style="
                          font-family: 'Inter-Regular';
                          font-style: normal;
                          font-weight: 500;
                          font-size: 14px;
                          line-height: 24px;
                          color: #28293d;
                        "
                      >
                        <tr v-for="kb in kbli" :key="kb.noKbli">
                          <td>
                            {{
                              kb.noKbli.length == 4
                                ? "0" + kb.noKbli
                                : kb.noKbli
                            }}
                          </td>
                          <td>{{ kb.deskripsi }}</td>
                          <td class="text-center">
                            {{ kb.tingkatResikoStr }}
                          </td>
                          <td class="text-center">
                            <a
                              v-if="
                                kb.fileSertifikat != null &&
                                kb.tingkatResiko != 4
                              "
                              class="text-decoration-none text-dark pointer"
                            >
                              Terverifikasi
                            </a>
                            <a v-else>-</a>
                          </td>
                          <td class="text-center">
                            <a
                              v-if="
                                kb.fileIzin != null && kb.tingkatResiko == 4
                              "
                              class="text-decoration-none text-dark pointer"
                            >
                              Terverifikasi
                            </a>
                            <a v-else>-</a>
                          </td>
                          <td class="text-start">
                            <img
                              :src="
                                kb.isVerified
                                  ? require('@/assets/icons/verified.png')
                                  : require('@/assets/icons/close-64.png')
                              "
                              alt="icon"
                              :style="{
                                width: kb.isVerified ? '6rem' : '4rem',
                                marginLeft: kb.isVerified ? '-0.8rem' : '0',
                              }"
                            />
                          </td>
                          <td>{{ kb.notes }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-md-10">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    SUB KONTRAKTOR
                  </p>
                </div>
              </div>
              <div class="row mb-5" v-if="subkontraktor != null">
                <div class="col-md-12">
                  <div
                    class="border border-1 border-light"
                    :class="{ 'bg-gray': index % 2 === 1 }"
                  >
                    <div class="table-responsive">
                      <table class="table table-striped rounded">
                        <tbody
                          style="
                            font-family: 'Inter-Regular';
                            font-style: normal;
                            font-weight: 500;
                            font-size: 14px;
                            line-height: 24px;
                            color: #28293d;
                          "
                        >
                          <tr
                            v-for="(sbk, index) in subkontraktor"
                            :key="index"
                          >
                            <td width="5%">{{ index + 1 }}</td>
                            <td width="85%">
                              <a
                                class="pointer link-danger text-decoration-none"
                                style=""
                                >{{ sbk.namaKontraktor }}</a
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-5" v-else>
                <p
                  class="mb-1 text-center"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  Tidak Ada Subkontraktor
                </p>
              </div>
              <div class="row" v-if="kontraktor.bidang != null">
                <div class="col-md-4">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    BIDANG
                  </p>
                  <ul class="list-group w-100">
                    <li
                      v-for="(bid, index) in bd"
                      :key="index"
                      :class="{
                        'list-group-item': true,
                        'list-bidang': true,
                        'bg-gray': index % 2 === 1,
                      }"
                    >
                      {{ bid }}
                    </li>
                  </ul>
                </div>
                <div class="col-md-8">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    SUB BIDANG
                  </p>
                  <table>
                    <tbody>
                    <tr
                      v-for="(sbid, index) in sbd"
                      :key="index"
                      :class="{ 'bg-gray': index % 2 === 1 }"
                    >
                      <td width="50%">{{ sbid.sb }}</td>
                      <td width="15%">
                        <img
                          :src="
                            sbid.is_verified
                              ? require('@/assets/icons/verified.png')
                              : require('@/assets/icons/close-64.png')
                          "
                          alt="icon"
                          :style="{
                            width: sbid.is_verified ? '6rem' : '4rem',
                            marginLeft: sbid.is_verified ? '.8rem' : '0',
                          }"
                        />
                      </td>
                      <td width="40%">{{ sbid.notes }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" v-else>
                <p
                  class="mb-1 text-center"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  Tidak Ada Data Bidang dan Sub Bidang
                </p>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>

  <div
    class="modal fade rounded-top-5"
    id="upload_coc_pjo"
    tabindex="-1"
    aria-labelledby="upload_coc_pjo"
    aria-hidden="true"
  >
    <div class="modal-dialog-centered rounded-top-5">
      <div
        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
        style="min-height: 156px; min-width: 350px"
      >
        <div
          class="modal-content rounded-bottom-5 rounded-top-4 border-0"
          style="
            min-height: 100px;
            min-width: 350px;
            background: rgba(181, 26, 26, 1);
          "
        >
          <div class="d-flex justify-content-end w-100 p-2">
            <button
              type="button"
              id="btnClose"
              class="btn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src="../../assets/icons/close_whaite.png"
                alt="icon"
                width="24"
                height="24"
              />
            </button>
          </div>
          <div
            class="p-3 text-white text-center mb-3"
            style="font-family: Inter, sans-serif"
          >
            <h5 class="fw-bold">Upload CoC & Surat Pengesahan PJO</h5>
          </div>
        </div>
        <div class="modal-body">
          <div class="p-1">
            <form @submit.prevent="OnFormSubmitUploadCoCSuratPengesahanPjo">
              <div class="d-flex justify-content-center">
                <div class="form-group mt-1 mb-2" style="width: 75%">
                  <div class="row mb-4">
                    <div class="col-12">
                      <label
                        for="fileDokumenCoc"
                        class="form-label fs-8 fw-bold"
                        >File CoC</label
                      >
                      <div class="input-group mb-1">
                        <input
                          type="file"
                          ref="fileDokumenCoc"
                          accept=".pdf"
                          class="form-control fs-9"
                          id="inputGroupFile04"
                          @change="handleChangeFile('docSio')"
                          aria-describedby="inputGroupFileAddon04"
                          aria-label="Upload"
                        />
                        <button
                          class="btn btn-outline-secondary fs-9 border border-start-0"
                          type="button"
                          id="inputGroupFileAddon04"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-cloud-arrow-up"
                            style="color: #000000"
                          />
                        </button>
                      </div>
                      <div
                        v-if="validasiFile.sizeCoc"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ukuran file melebihi batas (Max: {{ max_file_size }}MB).
                      </div>
                      <div
                        v-if="validasiFile.typeCoc"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ekstensi file tidak sesuai, Mohon tambahkan file PDF.
                      </div>
                      <div v-if="kontraktor.docSio != null" class="fs-8">
                        File saat ini :
                        <a
                          class="text-danger pointer"
                          @click="downloadFile(kontraktor.docSio)"
                        >
                          {{ kontraktor.docSio }}
                        </a>
                      </div>
                    </div>
                    <div class="col-12">
                      <label
                        for="filePengesahanPjo"
                        class="form-label fs-8 fw-bold"
                        >Surat Pengesahan PJO</label
                      >
                      <div class="input-group mb-1">
                        <input
                          type="file"
                          ref="fileDokumenPjo"
                          accept=".pdf"
                          class="form-control fs-9"
                          id="filePengesahanPjo"
                          @change="handleChangeFile('suratPengesahan')"
                          aria-describedby="inputGroupFileAddon04"
                          aria-label="Upload"
                        />
                        <button
                          class="btn btn-outline-secondary fs-9 border border-start-0"
                          type="button"
                          id="inputGroupFileAddon04"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-cloud-arrow-up"
                            style="color: #000000"
                          />
                        </button>
                      </div>
                      <div
                        v-if="validasiFile.sizePengesahanPjo"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ukuran file melebihi batas (Max: {{ max_file_size }}MB).
                      </div>
                      <div
                        v-if="validasiFile.typePengesahanPjo"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ekstensi file tidak sesuai, Mohon tambahkan file PDF.
                      </div>
                      <div
                        v-if="kontraktor.suratPengesahan != null"
                        class="fs-8"
                      >
                        File saat ini :
                        <a
                          class="text-danger pointer"
                          @click="downloadFile(kontraktor.suratPengesahan)"
                        >
                          {{ kontraktor.suratPengesahan }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  class="btn btn-sm bg-danger w-75 text-white"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade rounded-top-5"
    id="editKlasifikasi"
    tabindex="-1"
    aria-labelledby="editKlasifikasi"
    aria-hidden="true"
  >
    <div class="modal-dialog-centered rounded-top-5">
      <div
        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
        style="min-height: 156px; min-width: 350px"
      >
        <div
          class="modal-content rounded-bottom-5 rounded-top-4 border-0"
          style="
            min-height: 100px;
            min-width: 350px;
            background: rgba(181, 26, 26, 1);
          "
        >
          <div class="d-flex justify-content-end w-100 p-2">
            <button
              type="button"
              id="btnClose"
              class="btn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src="../../assets/icons/close_whaite.png"
                alt="icon"
                width="24"
                height="24"
              />
            </button>
          </div>
          <div
            class="p-3 text-white text-center mb-3"
            style="font-family: Inter, sans-serif"
          >
            <h4 class="fw-bold">Edit Klasifikasi</h4>
          </div>
        </div>
        <div class="modal-body">
          <div class="p-1">
            <form @submit.prevent="OnFormSubmitKlasifikasi">
              <div class="d-flex justify-content-center">
                <div class="form-group mt-1 mb-2" style="width: 75%">
                  <div class="row mb-4">
                    <div class="col-md-12">
                      <label for="klasifikasi" class="form-label fs-8 fw-bold"
                        >Klasifikasi</label
                      >
                      <select
                        class="form-select form-select-sm"
                        id="klasifikasi"
                        v-model="klasifikasi"
                      >
                        <option disabled value="" selected>
                          Pilih Klasifikasi
                        </option>
                        <option
                          :value="row"
                          v-for="row in klasifikasiOpt"
                          :key="row"
                        >
                          {{ row }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  class="btn btn-sm bg-danger w-75 text-white"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>

<style scoped>
table tr td,
table tr th {
  padding: 0.75rem 1rem;
}

section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}

.list-bidang {
  border-radius: 0px !important;
}

.bg-gray {
  background-color: #f2f2f5;
}

.bg-red-ss {
  background-color: #f8d7da;
}
.rounded-top-10 {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
</style>
<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import GlobalDataMixin from "../../GlobalDataMixin";
import Swal from "sweetalert2";

import axios from "axios";

import {
  API_BASE_URL,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_VIEW_IMAGE,
  CMS_DOWNLOAD,
  CMS_VIEW_DOCUMENT,
  CMS_GET_CHANGES_KONTRAKTOR,
  CMS_SET_KONTRAKTOR_PJP,
  CMS_UPLOAD_USECASE,
  CMS_GET_SIOID,
  CMS_DOWNLOAD_ESIGN,
} from "../../constants.js";
import router from "@/router";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import { downloadFile } from "@/utilities/globalFunction";

const url = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_download = API_BASE_URL + CMS_DOWNLOAD;
const url_simpan = API_BASE_URL + CMS_SET_KONTRAKTOR_PJP;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;
const url_get_changes_kontraktor = API_BASE_URL + CMS_GET_CHANGES_KONTRAKTOR;
const url_upload_usecase = API_BASE_URL + CMS_UPLOAD_USECASE;
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_download_esign = API_BASE_URL + CMS_DOWNLOAD_ESIGN;

const max_file_size = 5;

export default {
  mixins: [GlobalDataMixin],
  name: "ProfileKontraktorPreviewpage",
  components: { DefaultLayout },
  data() {
    return {
      isLoading: true,
      kontraktor: {},
      bidang: [],
      kbli: [],
      bd: [],
      sbd: [],
      // subkontraktor:['PT Sapta Indrasejati (SIS)','PT Rezki Batulicin Transport','PT Golden Energi Cemerlang Lestari (GECL)', 'PT Merdeka Sejati','PT Golden Gemilang','PT Jaya Sentosa'],
      subkontraktor: [],
      url_icon: "",
      url_file_nib: "",
      url_file_iujp: "",
      selectedOption: null,
      options: [
        { value: 1, label: "Kecil" },
        { value: 2, label: "Sedang" },
        { value: 3, label: "Besar" },
      ],
      predikatPjp: null,
      pjpOptions: [
        { value: "HIJAU", label: "HIJAU" },
        { value: "EMAS", label: "EMAS" },
        { value: "BIRU", label: "BIRU" },
        { value: "HITAM", label: "HITAM" },
        { value: "MERAH", label: "MERAH" },
      ],
      nilaiPjp: null,
      id_kontraktor: null,
      dataChanges: {},
      validasiFile: {
        typeCoc: false,
        sizeCoc: false,
        typePengesahanPjo: false,
        sizePengesahanPjo: false,
      },
      fileNameCoc: {
        docSio: null,
        suratPengesahan: null,
      },
      kontraktorID: null,
      klasifikasi: "",
      klasifikasiOpt: ["Inti", "Non Inti"],
      sio: {},
    };
  },
  methods: {
    fetchData(id) {
      axios
        .get(url + id)
        .then((response) => {
          console.log(response);
          this.kontraktor = response.data.detailKontraktor;
          this.url_icon =
            this.kontraktor.image != null
              ? API_BASE_URL + CMS_VIEW_IMAGE + this.kontraktor.image
              : "";
          this.url_file_nib =
            this.kontraktor.fileNib != null
              ? url_download + this.kontraktor.fileNib
              : null;
          this.url_file_iujp =
            this.kontraktor.fileIujp != null
              ? url_download + this.kontraktor.fileIujp
              : null;
          this.selectedOption = this.kontraktor.kualifikasiUsaha;
          this.predikatPjp = this.kontraktor.predikat;
          this.id_kontraktor = this.$route.params.id;
          this.nilaiPjp = this.kontraktor.nilaiPredikat;
          this.klasifikasi = this.kontraktor.jenis;
          // loop bidang-subbidang
          var arr_bid = [];
          var abd = [];
          var asbd = [];
          var temp_key = "";
          var b = 0;
          var sb = 1;
          for (var key in this.kontraktor.bidang) {
            var subi = this.kontraktor.bidang[key];
            if (temp_key != key) {
              temp_key = key;
              b += 1;
              sb = 1;
            }
            abd.push(b + ". " + key);

            for (var xx in subi) {
              arr_bid.push({
                bidang: b + ". " + key,
                subBidang: b + "." + sb + ". " + subi[xx],
              });
              asbd.push({
                sb: b + "." + sb + ". " + subi[xx].split("-")[0],
                is_verified: JSON.parse(subi[xx].split("-")[1]),
                notes:
                  subi[xx].split("-")[2] === "null"
                    ? null
                    : subi[xx].split("-")[2],
              });
              sb++;
            }
          }
          this.bidang = arr_bid;
          // end loop bidang-subbidang

          this.kbli = response.data.dataKbli;
          this.bd = abd;
          this.sbd = asbd;
          this.subkontraktor = response.data.subkontraktor;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data List Kontraktor : " + error.message);
          console.error("Error fetching data:", error);
        });
    },
    editProfile() {
      this.$router.push({
        name: "/editprofile",
        params: { id: this.$route.params.id },
      });
    },
    addSubkontraktor() {
      this.$router.push("/addsubkontraktor");
    },
    viewSubkontraktor(id) {
      this.$router.push("/subkontraktor/" + id);
    },
    toVerifikasiData(id) {
      this.$router.push("/verifikasiDataKontraktor/" + id);
    },
    redirectToLink(link, id) {
      router.push(link + id);
    },
    downloadFile,
    handleFileDownload(blobData, filename) {
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      console.log("blob nya = ", blob);
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename; // Set the desired file name
      link.click();
    },
    OnFormSubmit() {
      console.log("data nya = ", this.selectedOption);
      this.simpanKualifikasiUsaha(this.selectedOption);
    },
    simpanKualifikasiUsaha(selectedOptions) {
      // console.log('tp',this.formValues.tanggalPengesahan);
      let bodyJsonProfile = {
        id: this.$route.params.id,
        kualifikasiUsaha: selectedOptions,
        kblis: [],
      };
      axios
        .post(url_simpan, bodyJsonProfile, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response simpanEditProfile: ", response);
          window.location.reload();
        })
        .catch((error) => {
          console.log("error simpanEditProfile : ", error);
        });
    },
    OnFormSubmitPjp() {
      this.simpanPredikatPjp(this.predikatPjp, this.nilaiPjp);
    },
    simpanPredikatPjp(predikatPjp, nilaiPjp) {
      // console.log('tp',this.formValues.tanggalPengesahan);
      let bodyJsonProfile = {
        id: this.$route.params.id,
        predikat: predikatPjp,
        nilaiPredikat: nilaiPjp,
        kblis: [],
      };
      axios
        .post(url_simpan, bodyJsonProfile, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response simpanEditProfile: ", response);
          window.location.reload();
        })
        .catch((error) => {
          console.log("error simpanEditProfile : ", error);
        });
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
    getChangesKontraktor(kontraktorId) {
      let bodyJson = {
        kontraktorId: kontraktorId,
      };
      axios
        .post(url_get_changes_kontraktor, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          // console.log("response getChangesKontraktor: ", response)
          this.dataChanges = response.data;
          console.log(this.dataChanges);
        })
        .catch((error) => {
          console.log("error getChangesKontraktor : ", error);
        });
    },
    closeModal() {
      document.getElementById("btnClose").click();
    },
    handleChangeFile(refFile) {
      let file = null;
      if (refFile == "docSio") {
        file = this.$refs.fileDokumenCoc.files[0];
      } else if (refFile == "suratPengesahan") {
        file = this.$refs.fileDokumenPjo.files[0];
      }

      if (file) {
        // Check file type
        if (file.type !== "application/pdf") {
          if (refFile == "docSio") {
            this.validasiFile.typeCoc = true;
            this.validasiFile.sizeCoc = false;
            this.$refs.fileDokumenCoc.value = "";
          } else if (refFile == "suratPengesahan") {
            this.validasiFile.typePengesahanPjo = true;
            this.validasiFile.sizePengesahanPjo = false;
            this.$refs.fileDokumenPjo.value = "";
          }
          return;
        }

        // Check file size ({{max_file_size}}MB limit)
        if (file.size > max_file_size * 1024 * 1024) {
          if (refFile == "docSio") {
            this.validasiFile.typeCoc = false;
            this.validasiFile.sizeCoc = true;
            this.$refs.fileDokumenCoc.value = "";
          } else if (refFile == "suratPengesahan") {
            this.validasiFile.typePengesahanPjo = false;
            this.validasiFile.sizePengesahanPjo = true;
            this.$refs.fileDokumenPjo.value = "";
          }
          return;
        }

        // Reset error messages if the file is valid
        if (refFile == "docSio") {
          this.validasiFile.typeCoc = false;
          this.validasiFile.sizeCoc = false;
        } else if (refFile == "suratPengesahan") {
          this.validasiFile.typePengesahanPjo = false;
          this.validasiFile.sizePengesahanPjo = false;
        }

        // Handle the valid file as needed (e.g., store the file)
        // console.log('Valid file:', file);
      }
    },
    OnFormSubmitUploadCoCSuratPengesahanPjo() {
      if (!this.validasiFormFiles()) {
        alert("Lengkapi form yang wajib diisi !");
      } else {
        this.isLoading = true;
        const fileCoc = this.$refs.fileDokumenCoc.files[0];
        const fileDokumenPjo = this.$refs.fileDokumenPjo.files[0];
        let files = [];
        let purposes = [];

        if (fileCoc != null) {
          files.push(fileCoc);
          purposes.push("sio");
        }
        if (fileDokumenPjo != null) {
          files.push(fileDokumenPjo);
          purposes.push("pjo");
        }

        this.uploadFiles(files, purposes).then(() => this.alertSukses());
      }
    },
    async uploadFiles(files, purposes) {
      for (var x in files) {
        console.log(files[x]);
        console.log(purposes[x]);
        let file = files[x];
        let pur = purposes[x];

        if (file) {
          // Get the file name
          const fileName = file.name;

          // Create a FormData object and append the file
          const formData = new FormData();
          formData.append("file", file);
          formData.append("id", this.id_kontraktor);
          formData.append("purpose", pur);
          if (pur == "sio") {
            formData.append("usecase", "doc_sio");
          }
          if (pur == "pjo") {
            formData.append("usecase", "surat_pjo");
          }

          // Make the API request to upload the file
          try {
            const response = await axios.post(url_upload_usecase, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                role: "isafe",
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            // Handle the response from the server as needed
            console.log("File upload response:", response.data);
            console.log("filename : ", fileName);
          } catch (error) {
            // Handle errors, e.g., display an error message to the user
            alert("alert code [2] " + error.message);
            if (error.response.data != null) {
              alert("alert code [3] " + error.response.data.message);
            }
          }
        }
      }
    },
    validasiFormFiles() {
      if (
        this.$refs.fileDokumenCoc.value == "" &&
        (this.kontraktor.docSio == null || this.kontraktor.docSio == "") &&
        this.$refs.fileDokumenPjo.value == "" &&
        (this.kontraktor.suratPengesahan == null ||
          this.kontraktor.suratPengesahan == "")
      ) {
        return false;
      }
      return true;
    },
    alertSukses() {
      Swal.fire({
        title: "Upload Sukses",
        text: "Upload file berhasil disimpan!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        location.reload();
      });
    },
    OnFormSubmitKlasifikasi() {
      let bodyJsonProfile = {
        id: this.$route.params.id,
        iujp: this.klasifikasi == "Inti" ? true : false,
        kblis: [],
      };
      axios
        .post(url_simpan, bodyJsonProfile, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response OnFormSubmitKlasifikasi: ", response);
          window.location.reload();
        })
        .catch((error) => {
          console.log("error OnFormSubmitKlasifikasi : ", error);
        });
    },
    getSioID() {
      axios
        .get(url_get_sioid + this.kontraktorID, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Access-Control-Allow-Headers":
              "Content-Type, Authorization, Accept",
          },
        })
        .then((response) => {
          console.log("sio : ", response.data.data);
          // if (response.data.data != null) {
          this.sio = response.data.data;
          // }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    downloadFileEsign(id, type) {
      this.isLoading = true;
      let filename =
        type == "coc"
          ? `File CoC ${this.kontraktor.namaKontraktor}.zip`
          : `File Pengesahan PJO ${this.kontraktor.namaKontraktor}.zip`;
      axios
        .get(url_download_esign, {
          params: { id: id },
          headers: {
            role: this.userData.role,
            Authorization: `Bearer ${this.userData.token}`,
            Accept: "application/json",
          },
          responseType: "blob", // Ensure binary data handling
        })
        .then((response) => {
          if (response.status !== 200) {
            throw new Error("Network response was not ok");
          }
          // let filename = 'downloaded-file.zip'; // Default filename

          // surat coc => file coc nama kontraktor.zip
          // surat pjo => file pengesahan pjo nama kontraktor.zip
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); // Use the filename from the header or default one
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url); // Clean up the URL object
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error downloading file:", error);
        });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.kontraktorID = this.$route.params.id;
    this.fetchData(this.$route.params.id);
    this.getChangesKontraktor(this.$route.params.id);
    this.getSioID(this.$route.params.id);
  },
};
</script>
